import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { isItOpenApiRef } from './api';
import { DefaultApiClient } from '@internal/backstage-plugin-is-it-open-common';
import {
  compatWrapper,
  convertLegacyRouteRefs,
} from '@backstage/core-compat-api';
import {
  ApiBlueprint,
  createFrontendPlugin,
  FrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiDoorOpenLine } from '@remixicon/react';

const isItOpenPage = PageBlueprint.make({
  params: {
    icon: <RiDoorOpenLine />,
    title: 'Is It Open?',
    path: '/is-it-open',
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/IsItOpenFetchComponent').then(m =>
        compatWrapper(<m.IsItOpenFetchComponent />),
      ),
  },
});

const isItOpenApi = ApiBlueprint.make({
  name: 'is-it-open',
  params: defineParams =>
    defineParams({
      api: isItOpenApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory: ({ fetchApi, discoveryApi }) =>
        new DefaultApiClient({ discoveryApi, fetchApi }),
    }),
});

export const isItOpenPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'is-it-open',
  info: {
    // Load plugin info from package json
    packageJson: () => import('../package.json'),
  },
  // bind all the extensions to the plugin
  extensions: [isItOpenApi, isItOpenPage],
  routes: convertLegacyRouteRefs({
    root: rootRouteRef,
  }),
});
